import React, { Fragment, useState } from 'react'
import { StepperControls } from '../StepperTypes/StepperTypes'

interface StepperProps {
  children: (controls: StepperControls) => React.ReactNode
}

export const Stepper: React.FC<StepperProps> = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(0)
  const [currentState, setCurrentState] = useState<unknown>()

  const goToNextStep = (param?: unknown) => {
    setCurrentStep((current) => current + 1)
    setCurrentState(param)
  }

  const goToPreviousStep = (param?: unknown) => {
    setCurrentStep((current) => Math.max(current - 1, 0))
    setCurrentState(param)
  }

  const goToInitialStep = () => {
    setCurrentStep(0)
  }

  const goToStep = (step: number, param?: unknown) => {
    setCurrentState(param)
    setCurrentStep(step)
  }

  const controls = {
    currentStep,
    goToNextStep,
    goToPreviousStep,
    goToInitialStep,
    goToStep,
    currentState
  }

  return <Fragment>{children(controls)}</Fragment>
}
